"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[910],{

/***/ 910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(692);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/icons/dots-vertical.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDotsVertical = function SvgDotsVertical(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M10 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
  })));
};

/* harmony default export */ var dots_vertical = (SvgDotsVertical);
;// CONCATENATED MODULE: ./src/components/icons/github.svg
var github_path;

function github_extends() { github_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return github_extends.apply(this, arguments); }



var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/react.createElement("svg", github_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), github_path || (github_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0 1 12 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"
  })));
};

/* harmony default export */ var github = (SvgGithub);
// EXTERNAL MODULE: ./public/logo.svg
var logo = __webpack_require__(9238);
// EXTERNAL MODULE: ./src/components/popover.tsx
var popover = __webpack_require__(314);
;// CONCATENATED MODULE: ./src/components/icons/discord.svg
var discord_path;

function discord_extends() { discord_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return discord_extends.apply(this, arguments); }



var SvgDiscord = function SvgDiscord(props) {
  return /*#__PURE__*/react.createElement("svg", discord_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), discord_path || (discord_path = /*#__PURE__*/react.createElement("path", {
    d: "M20.317 4.537a19.596 19.596 0 0 0-4.885-1.536.074.074 0 0 0-.079.038c-.21.38-.444.877-.608 1.267-1.845-.28-3.68-.28-5.487 0a12.891 12.891 0 0 0-.617-1.267A.077.077 0 0 0 8.562 3c-1.714.3-3.354.824-4.885 1.536a.07.07 0 0 0-.032.028C.533 9.278-.32 13.875.099 18.414a.084.084 0 0 0 .031.057 19.797 19.797 0 0 0 5.993 3.071.077.077 0 0 0 .084-.028c.462-.639.874-1.313 1.226-2.022a.078.078 0 0 0-.041-.107 13.021 13.021 0 0 1-1.872-.904.079.079 0 0 1-.008-.13c.126-.095.252-.195.372-.295a.073.073 0 0 1 .078-.01c3.927 1.817 8.18 1.817 12.061 0a.073.073 0 0 1 .079.009c.12.1.245.2.372.296a.079.079 0 0 1-.006.13 12.23 12.23 0 0 1-1.873.903.078.078 0 0 0-.041.108c.36.708.772 1.382 1.225 2.021a.076.076 0 0 0 .084.03 19.731 19.731 0 0 0 6.002-3.072.078.078 0 0 0 .032-.056c.5-5.248-.838-9.807-3.549-13.849a.061.061 0 0 0-.031-.029ZM8.02 15.65c-1.182 0-2.157-1.1-2.157-2.452 0-1.352.956-2.453 2.157-2.453 1.21 0 2.176 1.11 2.157 2.453 0 1.351-.956 2.452-2.157 2.452Zm7.975 0c-1.183 0-2.157-1.1-2.157-2.452 0-1.352.955-2.453 2.157-2.453 1.21 0 2.176 1.11 2.157 2.453 0 1.351-.946 2.452-2.157 2.452Z"
  })));
};

/* harmony default export */ var discord = (SvgDiscord);
;// CONCATENATED MODULE: ./src/components/icons/star.svg
var star_path;

function star_extends() { star_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return star_extends.apply(this, arguments); }



var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/react.createElement("svg", star_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), star_path || (star_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 0 0 .95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 0 0-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 0 0-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 0 0-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 0 0 .951-.69l1.519-4.674z"
  })));
};

/* harmony default export */ var star = (SvgStar);
;// CONCATENATED MODULE: ./src/components/icons/translate.svg
var translate_path;

function translate_extends() { translate_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return translate_extends.apply(this, arguments); }



var SvgTranslate = function SvgTranslate(props) {
  return /*#__PURE__*/react.createElement("svg", translate_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "translate_svg__h-6 translate_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), translate_path || (translate_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 0 1 6.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
  })));
};

/* harmony default export */ var translate = (SvgTranslate);
;// CONCATENATED MODULE: ./src/components/icons/twitter.svg
var twitter_path;

function twitter_extends() { twitter_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return twitter_extends.apply(this, arguments); }



var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/react.createElement("svg", twitter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), twitter_path || (twitter_path = /*#__PURE__*/react.createElement("path", {
    d: "M24 4.557a9.83 9.83 0 0 1-2.828.775 4.932 4.932 0 0 0 2.165-2.724 9.864 9.864 0 0 1-3.127 1.195 4.916 4.916 0 0 0-3.594-1.555c-3.179 0-5.515 2.966-4.797 6.045A13.978 13.978 0 0 1 1.671 3.149a4.93 4.93 0 0 0 1.523 6.574 4.903 4.903 0 0 1-2.229-.616c-.054 2.281 1.581 4.415 3.949 4.89a4.935 4.935 0 0 1-2.224.084 4.928 4.928 0 0 0 4.6 3.419A9.9 9.9 0 0 1 0 19.54a13.94 13.94 0 0 0 7.548 2.212c9.142 0 14.307-7.721 13.995-14.646A10.025 10.025 0 0 0 24 4.557z"
  })));
};

/* harmony default export */ var twitter = (SvgTwitter);
;// CONCATENATED MODULE: ./public/digitalocean.svg
var _style, _g;

function digitalocean_extends() { digitalocean_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return digitalocean_extends.apply(this, arguments); }



var SvgDigitalocean = function SvgDigitalocean(props) {
  return /*#__PURE__*/react.createElement("svg", digitalocean_extends({
    id: "digitalocean_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 603 103",
    style: {
      enableBackground: "new 0 0 603 103"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".digitalocean_svg__st0,.digitalocean_svg__st1{fill:#0080ff}.digitalocean_svg__st1{fill-rule:evenodd;clip-rule:evenodd}")), _g || (_g = /*#__PURE__*/react.createElement("g", {
    id: "digitalocean_svg__XMLID_2369_"
  }, /*#__PURE__*/react.createElement("g", {
    id: "digitalocean_svg__XMLID_2638_"
  }, /*#__PURE__*/react.createElement("g", {
    id: "digitalocean_svg__XMLID_2639_"
  }, /*#__PURE__*/react.createElement("g", {
    id: "digitalocean_svg__XMLID_44_"
  }, /*#__PURE__*/react.createElement("g", {
    id: "digitalocean_svg__XMLID_48_"
  }, /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_49_",
    className: "digitalocean_svg__st0",
    d: "M52.1 102.1V82.5c20.8 0 36.8-20.6 28.9-42.4-3-8.1-9.4-14.6-17.5-17.5-21.8-7.9-42.4 8.1-42.4 28.9H1.5c0-33.1 32-58.9 66.7-48.1 15.2 4.7 27.2 16.8 31.9 31.9 10.8 34.8-14.9 66.8-48 66.8z"
  })), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_47_",
    className: "digitalocean_svg__st1",
    d: "M52.1 82.5H32.6V63h19.5z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_46_",
    className: "digitalocean_svg__st1",
    d: "M32.6 97.5h-15v-15h15v15z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_45_",
    className: "digitalocean_svg__st1",
    d: "M17.6 82.5H5V70h12.6z"
  })))), /*#__PURE__*/react.createElement("g", {
    id: "digitalocean_svg__XMLID_2370_"
  }, /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2635_",
    className: "digitalocean_svg__st0",
    d: "M181.5 30.2c-5.8-4-13-6.1-21.4-6.1h-18.3v58.1h18.3c8.4 0 15.6-2.1 21.4-6.4 3.2-2.2 5.7-5.4 7.4-9.3 1.7-3.9 2.6-8.5 2.6-13.7 0-5.1-.9-9.7-2.6-13.6-1.7-3.8-4.2-6.9-7.4-9zm-29 3.8h5.8c6.4 0 11.7 1.3 15.7 3.7 4.4 2.7 6.7 7.8 6.7 15.1 0 7.6-2.3 12.9-6.7 15.8-3.8 2.5-9.1 3.8-15.6 3.8h-5.8V34z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2634_",
    className: "digitalocean_svg__st0",
    d: "M204.3 23.4c-1.8 0-3.3.6-4.5 1.8-1.2 1.2-1.9 2.7-1.9 4.4 0 1.8.6 3.3 1.9 4.5 1.2 1.2 2.7 1.9 4.5 1.9 1.8 0 3.3-.6 4.5-1.9 1.2-1.2 1.9-2.8 1.9-4.5 0-1.8-.6-3.3-1.9-4.4-1.2-1.2-2.8-1.8-4.5-1.8z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2564_",
    className: "digitalocean_svg__st0",
    d: "M199 41.3h10.3v41H199z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2561_",
    className: "digitalocean_svg__st0",
    d: "M246.8 44.7c-3.1-2.8-6.6-4.4-10.3-4.4-5.7 0-10.4 2-14.1 5.8-3.7 3.8-5.5 8.8-5.5 14.7 0 5.8 1.8 10.7 5.5 14.7 3.7 3.8 8.4 5.8 14.1 5.8 4 0 7.4-1.1 10.2-3.3v1c0 3.4-.9 6-2.7 7.9-1.8 1.8-4.3 2.7-7.4 2.7-4.8 0-7.7-1.9-11.4-6.8l-7 6.7.2.3c1.5 2.1 3.8 4.2 6.9 6.2 3.1 2 6.9 3 11.5 3 6.1 0 11.1-1.9 14.7-5.6 3.7-3.7 5.5-8.7 5.5-14.9V41.3h-10.1v3.4zm-2.7 24.2c-1.8 2-4.1 3-7.1 3s-5.3-1-7-3c-1.8-2-2.7-4.7-2.7-8s.9-6.1 2.7-8.1c1.8-2 4.1-3.1 7-3.1 3 0 5.3 1 7.1 3.1 1.8 2 2.7 4.8 2.7 8.1s-1 6-2.7 8z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2560_",
    className: "digitalocean_svg__st0",
    d: "M265.7 41.3H276v41h-10.3z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2552_",
    className: "digitalocean_svg__st0",
    d: "M271 23.4c-1.8 0-3.3.6-4.5 1.8-1.2 1.2-1.9 2.7-1.9 4.4 0 1.8.6 3.3 1.9 4.5 1.2 1.2 2.7 1.9 4.5 1.9 1.8 0 3.3-.6 4.5-1.9 1.2-1.2 1.9-2.8 1.9-4.5 0-1.8-.6-3.3-1.9-4.4-1.2-1.2-2.8-1.8-4.5-1.8z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2509_",
    className: "digitalocean_svg__st0",
    d: "M298.6 30.3h-10.1v11.1h-5.9v9.4h5.9v17c0 5.3 1.1 9.1 3.2 11.3 2.1 2.2 5.8 3.3 11.1 3.3 1.7 0 3.4-.1 5-.2h.5v-9.4l-3.5.2c-2.5 0-4.1-.4-4.9-1.3-.8-.9-1.2-2.7-1.2-5.4V50.7h9.6v-9.4h-9.6v-11z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2508_",
    className: "digitalocean_svg__st0",
    d: "M356.5 24.1h10.3v58.1h-10.3z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2470_",
    className: "digitalocean_svg__st0",
    d: "M470.9 67.6c-1.8 2.1-3.7 3.9-5.2 4.8-1.4.9-3.2 1.4-5.3 1.4-3 0-5.5-1.1-7.5-3.4s-3-5.2-3-8.7 1-6.4 2.9-8.6c2-2.3 4.4-3.4 7.4-3.4 3.3 0 6.8 2.1 9.8 5.6l6.8-6.5c-4.4-5.8-10.1-8.5-16.9-8.5-5.7 0-10.6 2.1-14.6 6.1-4 4-6 9.2-6 15.3s2 11.2 6 15.3c4 4.1 8.9 6.1 14.6 6.1 7.5 0 13.5-3.2 17.5-9.1l-6.5-6.4z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2460_",
    className: "digitalocean_svg__st0",
    d: "M513.2 47c-1.5-2-3.5-3.7-5.9-4.9-2.5-1.2-5.3-1.8-8.5-1.8-5.8 0-10.5 2.1-14 6.3-3.4 4.2-5.2 9.3-5.2 15.4 0 6.2 1.9 11.3 5.7 15.3 3.7 3.9 8.8 5.9 14.9 5.9 6.9 0 12.7-2.8 16.9-8.4l.2-.3-6.7-6.5c-.6.8-1.5 1.6-2.3 2.4-1 1-2 1.7-3 2.2-1.5.8-3.3 1.1-5.2 1.1-2.9 0-5.2-.8-7-2.5-1.7-1.5-2.7-3.6-2.9-6.2h27.3l.1-3.8c0-2.7-.4-5.2-1.1-7.6-.7-2.3-1.8-4.5-3.3-6.6zm-22.5 9.7c.5-2 1.4-3.6 2.7-4.9 1.4-1.4 3.2-2.1 5.4-2.1 2.5 0 4.4.7 5.7 2.1 1.2 1.3 1.9 2.9 2.1 4.8h-15.9z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2456_",
    className: "digitalocean_svg__st0",
    d: "M552.8 44.4c-3.1-2.7-7.4-4-12.8-4-3.4 0-6.6.8-9.5 2.2-2.7 1.4-5.3 3.6-7 6.6l.1.1 6.6 6.3c2.7-4.3 5.7-5.8 9.7-5.8 2.2 0 3.9.6 5.3 1.7s2 2.6 2 4.4v2c-2.6-.8-5.1-1.2-7.6-1.2-5.1 0-9.3 1.2-12.4 3.6-3.1 2.4-4.7 5.9-4.7 10.2 0 3.8 1.3 7 4 9.3 2.7 2.2 6 3.4 9.9 3.4 3.9 0 7.6-1.6 10.9-4.3v3.4h10.1V55.9c.2-4.9-1.4-8.8-4.6-11.5zm-18.3 22.2c1.2-.8 2.8-1.2 4.9-1.2 2.5 0 5.1.5 7.8 1.5v4C545 73 542 74 538.3 74c-1.8 0-3.2-.4-4.1-1.2-.9-.8-1.4-1.7-1.4-3s.6-2.4 1.7-3.2z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2454_",
    className: "digitalocean_svg__st0",
    d: "M597.2 45.2c-2.9-3.2-6.9-4.8-12-4.8-4.1 0-7.4 1.2-9.9 3.5v-2.5h-10.1v41h10.3V59.7c0-3.1.7-5.6 2.2-7.3 1.5-1.8 3.4-2.6 6.1-2.6 2.3 0 4.1.8 5.4 2.3 1.3 1.6 2 3.7 2 6.4v23.7h10.3V58.5c0-5.6-1.4-10.1-4.3-13.3z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2450_",
    className: "digitalocean_svg__st0",
    d: "M343.6 44.4c-3.1-2.7-7.4-4-12.8-4-3.4 0-6.6.8-9.5 2.2-2.7 1.4-5.3 3.6-7 6.6l.1.1 6.6 6.3c2.7-4.3 5.7-5.8 9.7-5.8 2.2 0 3.9.6 5.3 1.7s2 2.6 2 4.4v2c-2.6-.8-5.1-1.2-7.6-1.2-5.1 0-9.3 1.2-12.4 3.6-3.1 2.4-4.7 5.9-4.7 10.2 0 3.8 1.3 7 4 9.3 2.7 2.2 6 3.4 9.9 3.4 3.9 0 7.6-1.6 10.9-4.3v3.4h10.1V55.9c.1-4.9-1.5-8.8-4.6-11.5zm-18.3 22.2c1.2-.8 2.8-1.2 4.9-1.2 2.5 0 5.1.5 7.8 1.5v4c-2.2 2.1-5.2 3.1-8.9 3.1-1.8 0-3.2-.4-4.1-1.2-.9-.8-1.4-1.7-1.4-3s.5-2.4 1.7-3.2z"
  }), /*#__PURE__*/react.createElement("path", {
    id: "digitalocean_svg__XMLID_2371_",
    className: "digitalocean_svg__st0",
    d: "M404.2 83.1c-16.5 0-30-13.4-30-30s13.4-30 30-30c16.5 0 30 13.4 30 30s-13.5 30-30 30zm0-49.3c-10.7 0-19.4 8.7-19.4 19.4s8.7 19.4 19.4 19.4 19.4-8.7 19.4-19.4-8.7-19.4-19.4-19.4z"
  })))));
};

/* harmony default export */ var digitalocean = (SvgDigitalocean);
;// CONCATENATED MODULE: ./public/sentry.svg
var sentry_path;

function sentry_extends() { sentry_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sentry_extends.apply(this, arguments); }



var SvgSentry = function SvgSentry(props) {
  return /*#__PURE__*/react.createElement("svg", sentry_extends({
    viewBox: "0 0 137 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), sentry_path || (sentry_path = /*#__PURE__*/react.createElement("path", {
    d: "M19.737 1.54a3.184 3.184 0 0 0-5.454 0L9.796 9.226A21.961 21.961 0 0 1 21.9 27.402h-3.15a18.873 18.873 0 0 0-10.541-15.49L4.055 19.09a10.855 10.855 0 0 1 6.294 8.297H3.114a.518.518 0 0 1-.422-.756l2.004-3.41a7.323 7.323 0 0 0-2.29-1.295L.42 25.337a3.095 3.095 0 0 0 1.153 4.254c.47.265 1 .406 1.54.409h9.907a13.227 13.227 0 0 0-5.454-11.802l1.575-2.728A16.276 16.276 0 0 1 16.165 30h8.393A24.463 24.463 0 0 0 13.369 8.318l3.184-5.454a.525.525 0 0 1 .716-.185c.361.198 13.834 23.707 14.086 23.98a.519.519 0 0 1-.463.77h-3.246c.041.869.041 1.735 0 2.598h3.26a3.13 3.13 0 0 0 2.727-4.698L19.737 1.541Zm64.991 17.742L74.665 6.286h-2.51v17.42H74.7v-13.35l10.35 13.35h2.222V6.287h-2.543v12.996ZM59.385 16.05h9.02v-2.264h-9.027V8.543h10.18V6.28h-12.77v17.428h12.9v-2.264h-10.31l.007-5.393Zm-10.61-2.21c-3.51-.845-4.492-1.513-4.492-3.136 0-1.459 1.288-2.447 3.211-2.447 1.751.051 3.44.66 4.82 1.738l1.364-1.93a9.614 9.614 0 0 0-6.136-2.045c-3.45 0-5.857 2.046-5.857 4.957 0 3.136 2.045 4.22 5.768 5.127 3.314.764 4.33 1.473 4.33 3.062 0 1.588-1.364 2.57-3.47 2.57a8.414 8.414 0 0 1-5.66-2.223l-1.534 1.835a10.868 10.868 0 0 0 7.105 2.625c3.736 0 6.136-2.012 6.136-5.12-.02-2.633-1.575-4.044-5.584-5.012Zm84.621-7.554-5.243 8.182-5.209-8.182h-3.041l6.88 10.534v6.893h2.618v-6.975l6.927-10.452h-2.932ZM89.33 8.646h5.707v15.067h2.618V8.646h5.707V6.286H89.337l-.007 2.36Zm26.141 8.263c2.632-.73 4.091-2.57 4.091-5.202 0-3.348-2.448-5.455-6.395-5.455h-7.746V23.7h2.591v-6.26h4.398l4.418 6.273h3.027l-4.772-6.695.388-.109Zm-7.466-1.705V8.591h4.889c2.55 0 4.009 1.207 4.009 3.3s-1.561 3.313-3.982 3.313h-4.916Z",
    fill: "#362D59"
  })));
};

/* harmony default export */ var sentry = (SvgSentry);
;// CONCATENATED MODULE: ./public/vercel-logotype-dark.svg
var vercel_logotype_dark_path;

function vercel_logotype_dark_extends() { vercel_logotype_dark_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vercel_logotype_dark_extends.apply(this, arguments); }



var SvgVercelLogotypeDark = function SvgVercelLogotypeDark(props) {
  return /*#__PURE__*/react.createElement("svg", vercel_logotype_dark_extends({
    viewBox: "0 0 4438 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), vercel_logotype_dark_path || (vercel_logotype_dark_path = /*#__PURE__*/react.createElement("path", {
    d: "M2223.75 250c-172.5 0-296.88 112.5-296.88 281.25s139.85 281.25 312.51 281.25c104.21 0 196.09-41.25 252.96-110.781l-119.53-69.063c-31.56 34.532-79.53 54.688-133.43 54.688-74.85 0-138.44-39.063-162.04-101.563h437.82c3.43-17.5 5.47-35.625 5.47-54.687C2520.63 362.5 2396.41 250 2223.75 250Zm-147.66 226.562C2095.62 414.219 2149.06 375 2223.75 375c74.84 0 128.28 39.219 147.66 101.562h-295.32Zm-35.31-398.437-432.97 750-433.12-750h162.34l270.63 468.75 270.62-468.75h162.5ZM577.344 0l577.346 1000H0L577.344 0ZM3148.75 531.25C3148.75 625 3210 687.5 3305 687.5c64.38 0 112.66-29.219 137.5-76.875l120 69.219C3512.81 762.656 3419.69 812.5 3305 812.5c-172.66 0-296.87-112.5-296.87-281.25S3132.5 250 3305 250c114.69 0 207.66 49.844 257.5 132.656l-120 69.219C3417.66 404.219 3369.38 375 3305 375c-94.84 0-156.25 62.5-156.25 156.25ZM4437.5 78.125v718.75h-140.62V78.125h140.62ZM3906.25 250c-172.5 0-296.87 112.5-296.87 281.25s140 281.25 312.5 281.25c104.21 0 196.09-41.25 252.96-110.781l-119.53-69.063c-31.56 34.532-79.53 54.688-133.43 54.688-74.85 0-138.44-39.063-162.04-101.563h437.82c3.43-17.5 5.46-35.625 5.46-54.687C4203.12 362.5 4078.91 250 3906.25 250Zm-147.66 226.562C3778.13 414.219 3831.41 375 3906.25 375s128.28 39.219 147.66 101.562h-295.32Zm-797.34-210.937v151.406c-15.62-4.531-32.19-7.656-50-7.656-90.78 0-156.25 62.5-156.25 156.25v231.25h-140.62v-531.25H2755v143.75c0-79.375 92.34-143.75 206.25-143.75Z",
    fill: "#000"
  })));
};

/* harmony default export */ var vercel_logotype_dark = (SvgVercelLogotypeDark);
// EXTERNAL MODULE: ./src/components/poll/language-selector.tsx
var language_selector = __webpack_require__(4563);
;// CONCATENATED MODULE: ./src/components/layouts/page-layout/footer.tsx














const Footer = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-16 bg-gradient-to-b from-gray-50/0 via-gray-50 to-gray-50 ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto max-w-7xl space-y-8 p-8 lg:flex lg:space-x-16 lg:space-y-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " lg:w-2/6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                            className: "w-32 text-slate-400"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-8 mt-4 text-slate-400",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                        t: t,
                                        i18nKey: "footerSponsor",
                                        components: {
                                            a: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "font-normal leading-loose text-slate-400 underline hover:text-slate-800 hover:underline",
                                                href: "https://www.paypal.com/donate/?hosted_button_id=7QXP2CUBLY88E"
                                            })
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                        t: t,
                                        i18nKey: "footerCredit",
                                        components: {
                                            a: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "font-normal leading-loose text-slate-400 underline hover:text-slate-800 hover:underline",
                                                href: "https://twitter.com/imlukevella"
                                            })
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-8 flex items-center space-x-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://twitter.com/ralllyco",
                                    className: "text-sm text-slate-400 transition-colors hover:text-primary-500 hover:no-underline",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter, {
                                        className: "h-5 w-5"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://discord.gg/uzg4ZcHbuM",
                                    className: "text-sm text-slate-400 transition-colors hover:text-primary-500 hover:no-underline",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(discord, {
                                        className: "h-5 w-5"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: "https://github.com/lukevella/rallly",
                                    className: "inline-flex h-8 items-center rounded-full bg-slate-100 pl-2 pr-3 text-sm text-slate-400 transition-colors hover:bg-primary-500 hover:text-white hover:no-underline focus:ring-2 focus:ring-primary-500 focus:ring-offset-1 active:bg-primary-600",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(star, {
                                            className: "mr-2 inline-block w-5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("starOnGithub")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:w-1/6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-4 font-medium",
                            children: t("links")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "space-y-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-block font-normal text-slate-400 hover:text-slate-800 hover:no-underline",
                                        href: "https://github.com/lukevella/rallly/discussions",
                                        children: t("discussions")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://blog.rallly.co",
                                        className: "inline-block font-normal text-slate-400 hover:text-slate-800 hover:no-underline",
                                        children: t("blog")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://support.rallly.co",
                                        className: "inline-block font-normal text-slate-400 hover:text-slate-800 hover:no-underline",
                                        children: t("support")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/privacy-policy",
                                        className: "inline-block font-normal text-slate-400 hover:text-slate-800 hover:no-underline",
                                        children: t("privacyPolicy")
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:w-1/6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-4 font-medium",
                            children: t("poweredBy")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "block space-y-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://vercel.com?utm_source=rallly&utm_campaign=oss",
                                        className: "inline-block text-white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vercel_logotype_dark, {
                                            className: "h-5"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-block",
                                        href: "https://m.do.co/c/f91efc9c9e50",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(digitalocean, {
                                            className: "h-7"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-block",
                                        href: "https://sentry.io",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sentry, {
                                            className: "h-6"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:w-2/6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-4 font-medium",
                            children: t("language")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(language_selector/* LanguageSelect */.S, {
                            className: "mb-4 w-full",
                            onChange: (locale)=>{
                                router.push(router.asPath, router.asPath, {
                                    locale
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: "https://github.com/lukevella/rallly/wiki/Guide-for-translators",
                            className: "inline-flex items-center rounded-md border px-3 py-2 text-xs text-slate-500 hover:border-primary-500 hover:text-primary-500",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(translate, {
                                    className: "mr-2 h-5 w-5"
                                }),
                                t("volunteerTranslator"),
                                " →"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var footer = (Footer);

;// CONCATENATED MODULE: ./src/components/layouts/page-layout.tsx











const Menu = (param)=>{
    let { className  } = param;
    const { pathname  } = (0,next_router.useRouter)();
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                className: (0,clsx_m/* default */.Z)("text-gray-400 transition-colors hover:text-primary-500 hover:no-underline hover:underline-offset-2", {
                    "pointer-events-none font-bold text-gray-600": pathname === "/home"
                }),
                children: t("home")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "https://blog.rallly.co",
                className: (0,clsx_m/* default */.Z)("text-gray-400 transition-colors hover:text-primary-500 hover:no-underline hover:underline-offset-2"),
                children: t("blog")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://support.rallly.co",
                className: "text-gray-400 transition-colors hover:text-primary-500 hover:no-underline hover:underline-offset-2",
                children: t("support")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "https://github.com/lukevella/rallly",
                className: "text-gray-400 transition-colors hover:text-primary-500 hover:no-underline hover:underline-offset-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(github, {
                    className: "w-6"
                })
            })
        ]
    });
};
const PageLayout = (param)=>{
    let { children  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("homepage");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-pattern min-h-full overflow-x-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto flex max-w-7xl items-center py-8 px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grow",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative inline-block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* default */.Z, {
                                        className: "w-40 text-primary-500",
                                        alt: "Rallly"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "absolute -bottom-6 right-0 text-sm text-slate-400 transition-colors",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                                        t: t,
                                        i18nKey: "3Ls",
                                        components: {
                                            e: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {})
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
                        className: "hidden items-center space-x-8 md:flex"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverTrigger */.xo, {
                                asChild: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "text-gray-400 transition-colors hover:text-primary-500 hover:no-underline hover:underline-offset-2 sm:hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dots_vertical, {
                                        className: "w-5"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverContent */.yk, {
                                align: "start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
                                    className: "flex flex-col space-y-2"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:min-h-[calc(100vh-460px)]",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    });
};
/* harmony default export */ var page_layout = (PageLayout);


/***/ }),

/***/ 4563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ LanguageSelect; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1955);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(692);




const LanguageSelect = (param)=>{
    let { className , onChange  } = param;
    const { i18n  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("input", className),
        defaultValue: i18n.language,
        onChange: (e)=>{
            js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .Z.set("NEXT_LOCALE", e.target.value, {
                expires: 365
            });
            onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "en",
                children: "English"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "ca",
                children: "Catal\xe0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "cs",
                children: "Česky"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "zh",
                children: "汉语"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "da",
                children: "Dansk"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "de",
                children: "Deutsch"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "es",
                children: "Espa\xf1ol"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "fi",
                children: "Suomi"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "fr",
                children: "Fran\xe7ais"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "hr",
                children: "Hrvatski"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "it",
                children: "Italiano"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "ko",
                children: "한국어"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "hu",
                children: "Magyar"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "nl",
                children: "Nederlands"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "pl",
                children: "Polski"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "pt",
                children: "Portugu\xeas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "pt-BR",
                children: "Portugu\xeas - Brasil"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "ru",
                children: "Pусский"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "sk",
                children: "Slovenčina"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "sv",
                children: "Svenska"
            })
        ]
    });
};


/***/ }),

/***/ 314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J2": function() { return /* binding */ Popover; },
/* harmony export */   "xo": function() { return /* binding */ PopoverTrigger; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6055);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
"use client";




const Popover = _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC;
const PopoverTrigger = _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz;
const PopoverContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , align ="center" , sideOffset =4 , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__/* .Portal */ .h_, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("z-50 animate-popIn rounded-md border bg-white p-1 shadow-md outline-none", {
                "origin-top-left": align === "start",
                "origin-top-right": align === "end"
            }, className),
            ...props
        })
    });
});
PopoverContent.displayName = _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__/* .Content.displayName */ .VY.displayName;



/***/ })

}]);